import { Box, Stack, Text } from '@chakra-ui/react';

import CertificateModal from '../../../../../shared/certificates/CertificateModal';
import CertificateV2 from '../../../../../shared/certificates/CertificateV2';
import type { UserCertificate } from '@/client/types/content/UserCertificate';
import { format } from 'date-fns';
import { useParseCertificateData } from '../../../../../shared/certificates/hooks/useParseCertificateData';
import { useState } from 'react';

export default function LearnerDashboardCertificatePreviewCard({
  certificate,
}: {
  certificate: UserCertificate;
}) {
  const [isHovered, setIsHovered] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { displayTitle, hideDate } = useParseCertificateData(certificate);

  const handleCertificateClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      <Box
        key={certificate.title}
        width={{ base: 'full', md: '240px' }}
        backgroundColor="white"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        _hover={{ cursor: 'pointer' }}
        onClick={handleCertificateClick}
      >
        <CertificateV2 certificate={certificate} variant="preview" isHovered={isHovered} />

        <Stack spacing={2} marginTop={2}>
          <Text fontSize="16px" fontWeight={600} color="baseBlack">
            {displayTitle}
          </Text>

          {!hideDate && (
            <Text fontSize="12px" fontWeight={500} color="neutral.800">
              {format(new Date(certificate.completedDate), 'MMMM do, yyyy')}
            </Text>
          )}
        </Stack>
      </Box>

      <CertificateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        certificate={certificate}
      />
    </>
  );
}
